
import { Vue, Component, Prop } from "vue-property-decorator";
import { Project, User, Project_Activity } from "@/generated/graphql";
import ContractorsMultiselect from "@/components/autocompleteMultiselects/ContractorsMultiselectNew.vue";
import ManagementActivityCard from "@/components/projects/activities/ManagementActivityCardNew.vue";
import TableHeaders from "@/views/manage/projectDetails/ActivityHeaders.vue";
import CardPagination from "@/components/card/PaginationNew.vue";
import EmptyListPlaceholder from "@/components/common/EmptyListPlaceholderNew.vue";
import ActivityCustomRequest from "@/components/projects/activities/ActivityCustomRequest.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import GET_ACTIVITIES from "@/apollo/projectActivities/GetActivities.gql";
import RouteNames from "@/entities/RouteNames";
import InfoCircleFilled from "@/components/icons/InfoCircleFilled.vue";
import HoveredIcon from "@/components/icons/ArrowIconBlue.vue";
import LoadingOverlay from "@/components/common/LoadingOverlay.vue";

@Component({
  components: {
    ContractorsMultiselect,
    InfoCircleFilled,
    ManagementActivityCard,
    TableHeaders,
    HoveredIcon,
    CardPagination,
    LoadingOverlay,
    EmptyListPlaceholder,
    ActivityCustomRequest,
    FormGroup,
  },
  apollo: {
    activitiesActive: {
      query: GET_ACTIVITIES,
      variables() {
        return this.getActivitiesArgsCurrent;
      },
      update(data) {
        this.activitiesActive = data.project_activity;
        return Array.isArray(data.project_activity)
          ? data.project_activity
          : [];
      },
    },
  },
})
export default class CurrentVisits extends Vue {
  @Prop({ type: Object, required: true }) readonly project!: Project;
  @Prop({ type: String, required: true }) readonly userRole!: string;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: String, required: true }) readonly companyId!: string;

  contractorsIdsActive: string[] = [];
  activitiesActive: Project_Activity[] = [];
  paginationConfig = {
    page: 1,
    total: 0,
    limit: 8,
    loadedCount: 0,
  };

  get getActivitiesArgsCurrent() {
    const filterConditions = [];
    if (this.contractorsIdsActive.length > 0) {
      filterConditions.push({
        contractor: {
          id: {
            _in: this.contractorsIdsActive,
          },
        },
      });
    }
    // Use current UTC time minus 24 hours for the filter
    const nowUtc = this.$moment.utc().toISOString();
    return {
      where: {
        _and: [
          ...filterConditions,
          { project_id: { _eq: this.$route.params.id } },
          { deleted: { _eq: false } },
          { completed: { _eq: false } },
          { drafted: { _eq: false } },
          {
            _or: [
              { checkin_status: { _is_null: false } },
              { end_time: { _gt: nowUtc } },
            ],
          },
        ],
      },
    };
  }

  handleListToggle() {
    this.$router.push({
      name: RouteNames.CALENDAR,
      query: {
        selectedClientId: this.project.id,
      },
    });
  }

  get isLoading(): boolean {
    return this.$apollo.queries.activitiesActive.loading;
  }

  // Check if activities are loaded
  get isActivitiesLoaded(): boolean {
    return this.isLoading && !!this.activitiesActive;
  }
  get isEmpty() {
    return !this.activitiesActive || this.activitiesActive.length === 0;
  }

  matchesSearch(activity, searchInput) {
    const assigneeId = activity.contractor?.user.id;
    return !searchInput.length || searchInput.includes(assigneeId);
  }

  updateContractorsFilter(selectedContractors) {
    this.contractorsIdsActive = selectedContractors;
  }

  handlePaginationEvent(newConfig) {
    this.paginationConfig = { ...newConfig };
  }

  onActivityListItemsChanged() {
    this.$apollo.queries.activitiesActive.refetch();
    this.$emit("activityListChanged");
  }

  get isManager() {
    return this.userRole === "Manager";
  }
}
